import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import BookCard from '@/components/book-card/BookCard.vue';
import axios from '@/config/axios';

const CATEGORY_MAP = {
  'ÂM NHẠC': {
    icon: 'fa-solid fa-music',
    desc: 'Lắng nghe thanh âm cuộc sống, khám phá lịch sử và lý thuyết đằng sau những giai điệu và tuyệt tác bất hủ.',
    theme: 'theme-music'
  },
  'ẨM THỰC': {
    icon: 'fa-solid fa-utensils',
    desc: 'Nghệ thuật ẩm thực phong phú và hành trình khám phá những hương vị văn hóa tinh tế khắp năm châu.',
    theme: 'theme-food'
  },
  'CHÂN DUNG VĂN HỌC': {
    icon: 'fa-solid fa-user-pen',
    desc: 'Khắc họa cuộc đời, tư tưởng và di sản của những bậc đại thụ và gương mặt tiêu biểu trên văn đàn.',
    theme: 'theme-literature'
  },
  'CHÍNH TRỊ': {
    icon: 'fa-solid fa-building-columns',
    desc: 'Phân tích các học thuyết quyền lực, cấu trúc thể chế và những chuyển động địa chính trị toàn cầu.',
    theme: 'theme-business'
  },
  'CÔNG NGHỆ': {
    icon: 'fa-solid fa-microchip',
    desc: 'Cập nhật những bước tiến đột phá về công nghệ số, xu hướng tương lai và sự chuyển dịch của thời đại.',
    theme: 'theme-science'
  },
  'DÂN GIAN': {
    icon: 'fa-solid fa-scroll',
    desc: 'Lưu giữ kho tàng truyện cổ, ca dao và nét đẹp văn hóa truyền thống ngàn đời của dân tộc.',
    theme: 'theme-literature'
  },
  'ĐIỆN ẢNH': {
    icon: 'fa-solid fa-film',
    desc: 'Khám phá nghệ thuật thứ bảy, ngôn ngữ điện ảnh và hậu trường của những tác phẩm màn bạc kinh điển.',
    theme: 'theme-music'
  },
  'DU LỊCH': {
    icon: 'fa-solid fa-compass',
    desc: 'Khơi dậy niềm đam mê xê dịch, cẩm nang trải nghiệm và những vùng đất mới lạ khắp thế giới.',
    theme: 'theme-food'
  },
  'FANTASY': {
    icon: 'fa-solid fa-wand-magic-sparkles',
    desc: 'Bước vào những thế giới huyền bí, phép thuật kỳ diệu và cuộc phiêu lưu vượt ngoài trí tưởng tượng.',
    theme: 'theme-literature'
  },
  'GIẢ TƯỞNG': {
    icon: 'fa-solid fa-rocket',
    desc: 'Hình dung về tương lai nhân loại, công nghệ siêu tưởng và những chiều không gian bí ẩn ngoài vũ trụ.',
    theme: 'theme-science'
  },
  'HÀI HƯỚC': {
    icon: 'fa-solid fa-face-laugh-beam',
    desc: 'Mang lại tiếng cười sảng khoái, góc nhìn hóm hỉnh và năng lượng tích cực cho cuộc sống thường nhật.',
    theme: 'theme-skills'
  },
  'HỘI HỌA': {
    icon: 'fa-solid fa-palette',
    desc: 'Thưởng lãm cái đẹp, cảm nhận chiều sâu thị giác và ngôn ngữ sáng tạo qua lăng kính nghệ thuật.',
    theme: 'theme-music'
  },
  'HỒI KÝ': {
    icon: 'fa-solid fa-feather-pointed',
    desc: 'Những trang nhật ký chân thật, thăng trầm cuộc đời và bài học vô giá từ những nhân chứng lịch sử.',
    theme: 'theme-literature'
  },
  'KHOA HỌC': {
    icon: 'fa-solid fa-atom',
    desc: 'Mở rộng tầm nhìn tri thức và khám phá những bí ẩn, quy luật kỳ diệu của tự nhiên và vũ trụ.',
    theme: 'theme-science'
  },
  'KỊCH BẢN': {
    icon: 'fa-solid fa-masks-theater',
    desc: 'Nghệ thuật xây dựng cốt truyện, lời thoại nhân vật và cấu trúc kịch bản sân khấu, điện ảnh.',
    theme: 'theme-literature'
  },
  'KỊCH TÍNH': {
    icon: 'fa-solid fa-bolt',
    desc: 'Những câu chuyện nghẹt thở, cao trào dồn dập và những bước ngoặt bất ngờ không thể đoán trước.',
    theme: 'theme-literature'
  },
  'KINH DỊ': {
    icon: 'fa-solid fa-ghost',
    desc: 'Khơi gợi nỗi sợ tiềm thức, những câu chuyện rùng rợn và bí ẩn bóng tối đầy mê hoặc.',
    theme: 'theme-literature'
  },
  'KINH ĐIỂN': {
    icon: 'fa-solid fa-award',
    desc: 'Những áng văn bất hủ vượt thời gian, trường tồn cùng năm tháng và định hình tư duy bao thế hệ.',
    theme: 'theme-literature'
  },
  'KINH DOANH': {
    icon: 'fa-solid fa-chart-line',
    desc: 'Chiến lược quản trị, tư duy thị trường và bài học kinh doanh đắt giá từ các nhà lãnh đạo xuất sắc.',
    theme: 'theme-business'
  },
  'KINH TẾ': {
    icon: 'fa-solid fa-coins',
    desc: 'Bức tranh kinh tế toàn cảnh, quy luật thị trường và tư duy tài chính định hình xã hội hiện đại.',
    theme: 'theme-business'
  },
  'KỲ ẢO': {
    icon: 'fa-solid fa-wand-magic-sparkles',
    desc: 'Thế giới huyền thoại, phép thuật nhiệm màu và những thiên sử thi kỳ vĩ vượt thời không.',
    theme: 'theme-literature'
  },
  'KỸ NĂNG': {
    icon: 'fa-solid fa-seedling',
    desc: 'Tự hoàn thiện và bồi đắp kỹ năng mỗi ngày qua những phương pháp thực tiễn từ chuyên gia.',
    theme: 'theme-skills'
  },
  'KỸ NĂNG SỐNG': {
    icon: 'fa-solid fa-seedling',
    desc: 'Tự hoàn thiện bản thân, rèn luyện tư duy tích cực và làm chủ cuộc sống mỗi ngày.',
    theme: 'theme-skills'
  },
  'LÃNG MẠN': {
    icon: 'fa-solid fa-heart',
    desc: 'Những câu chuyện tình yêu ngọt ngào, cảm xúc rung động sâu lắng và thi vị trong đời sống.',
    theme: 'theme-music'
  },
  'LỊCH SỬ': {
    icon: 'fa-solid fa-landmark',
    desc: 'Nhìn lại quá khứ để hiểu sâu sắc hơn về hiện tại và bước tiến của các nền văn minh nhân loại.',
    theme: 'theme-literature'
  },
  'LIGHT NOVEL': {
    icon: 'fa-solid fa-book-open',
    desc: 'Tiểu thuyết đương đại Nhật Bản với cốt truyện cuốn hút, minh họa sống động và ngôn từ trẻ trung.',
    theme: 'theme-literature'
  },
  'NGHỆ THUẬT': {
    icon: 'fa-solid fa-palette',
    desc: 'Nuôi dưỡng tâm hồn qua cái đẹp, tư duy sáng tạo và những tuyệt tác nghệ thuật kinh điển.',
    theme: 'theme-music'
  },
  'NGHIÊN CỨU': {
    icon: 'fa-solid fa-microscope',
    desc: 'Những công trình học thuật nghiêm cẩn, luận bàn chuyên sâu và kiến giải tri thức giá trị.',
    theme: 'theme-science'
  },
  'NGOẠI NGỮ': {
    icon: 'fa-solid fa-language',
    desc: 'Cầu nối ngôn ngữ và văn hóa toàn cầu, mở rộng cơ hội học tập và hội nhập quốc tế.',
    theme: 'theme-skills'
  },
  'NGOẠI VĂN': {
    icon: 'fa-solid fa-globe',
    desc: 'Tuyển tập các ấn phẩm nguyên bản xuất sắc từ các tác giả và nhà xuất bản hàng đầu thế giới.',
    theme: 'theme-literature'
  },
  'NGÔN TÌNH': {
    icon: 'fa-solid fa-heart-pulse',
    desc: 'Những thiên tình sử sâu sắc, thăng trầm cảm xúc và tình yêu đôi lứa khắc cốt ghi tâm.',
    theme: 'theme-music'
  },
  'NUÔI DẠY CON': {
    icon: 'fa-solid fa-hands-holding-child',
    desc: 'Cẩm nang đồng hành cùng con yêu, nuôi dưỡng thể chất và tâm hồn trẻ bằng phương pháp khoa học.',
    theme: 'theme-skills'
  },
  'PHÊ BÌNH VĂN HỌC': {
    icon: 'fa-solid fa-magnifying-glass-chart',
    desc: 'Góc nhìn phân tích, thẩm định nghệ thuật và giải mã những chiều sâu tư tưởng sau trang sách.',
    theme: 'theme-literature'
  },
  'PHIÊU LƯU': {
    icon: 'fa-solid fa-mountain-sun',
    desc: 'Dấn thân vào những miền đất hiểm trở, vượt qua thử thách và khát vọng chinh phục thế giới.',
    theme: 'theme-food'
  },
  'SELF-HELP': {
    icon: 'fa-solid fa-seedling',
    desc: 'Khai mở tiềm năng bản thân, vượt qua giới hạn và kiến tạo cuộc đời thành công, hạnh phúc.',
    theme: 'theme-skills'
  },
  'SERIES': {
    icon: 'fa-solid fa-layer-group',
    desc: 'Tuyển tập trọn bộ các phần tiếp nối, đưa bạn vào hành trình trải nghiệm liền mạch và trọn vẹn.',
    theme: 'theme-literature'
  },
  'SỬ THI': {
    icon: 'fa-solid fa-shield-halved',
    desc: 'Khúc tráng ca vĩ đại ca ngợi các anh hùng, chiến công hiển hách và cội nguồn dân tộc.',
    theme: 'theme-literature'
  },
  'SỨC KHỎE': {
    icon: 'fa-solid fa-heart-pulse',
    desc: 'Cẩm nang chăm sóc sức khỏe toàn diện, y học thực chứng và duy trì lối sống an lành, khỏe khoắn.',
    theme: 'theme-skills'
  },
  'TÀI CHÍNH': {
    icon: 'fa-solid fa-coins',
    desc: 'Quản trị dòng tiền cá nhân, tư duy đầu tư thông minh và xây dựng nền tảng tự do tài chính.',
    theme: 'theme-business'
  },
  'TÂM LINH': {
    icon: 'fa-solid fa-sun',
    desc: 'Tìm kiếm sự an yên nội tại, đánh thức trực giác và thấu hiểu chiều sâu tâm thức con người.',
    theme: 'theme-literature'
  },
  'TÂM LÝ': {
    icon: 'fa-solid fa-brain',
    desc: 'Giải mã hành vi con người, thấu hiểu cảm xúc và xây dựng nội lực tinh thần vững vàng.',
    theme: 'theme-skills'
  },
  'TẢN VĂN': {
    icon: 'fa-solid fa-mug-saucer',
    desc: 'Những góc nhìn nhẹ nhàng, chiêm nghiệm đời thường và cảm xúc lắng đọng qua ngòi bút tinh tế.',
    theme: 'theme-literature'
  },
  'THẦN THOẠI': {
    icon: 'fa-solid fa-feather',
    desc: 'Thế giới các vị thần, khởi nguyên vạn vật và những huyền thoại cổ xưa bất hủ của nhân loại.',
    theme: 'theme-literature'
  },
  'THỂ NGHIỆM': {
    icon: 'fa-solid fa-flask-vial',
    desc: 'Những tác phẩm phá cách, đổi mới thi pháp và thể nghiệm nghệ thuật độc đáo, mới lạ.',
    theme: 'theme-science'
  },
  'THỂ THAO': {
    icon: 'fa-solid fa-medal',
    desc: 'Ý chí kiên cường, tinh thần đồng đội và cảm hứng vươn tới đỉnh cao vinh quang thể thao.',
    theme: 'theme-business'
  },
  'THIÊN NHIÊN': {
    icon: 'fa-solid fa-tree',
    desc: 'Hòa mình vào thiên nhiên hoang dã, bảo vệ môi trường và trân quý vẻ đẹp của tạo hóa.',
    theme: 'theme-skills'
  },
  'THIẾU NHI': {
    icon: 'fa-solid fa-child-reaching',
    desc: 'Khơi dậy trí tưởng tượng phong phú, niềm say mê khám phá và gieo mầm ước mơ cho tuổi thơ.',
    theme: 'theme-kids'
  },
  'THẾU NHI': {
    icon: 'fa-solid fa-child-reaching',
    desc: 'Khơi dậy trí tưởng tượng phong phú, niềm say mê khám phá và gieo mầm ước mơ cho tuổi thơ.',
    theme: 'theme-kids'
  },
  'THƠ': {
    icon: 'fa-solid fa-feather-pointed',
    desc: 'Ngôn từ thăng hoa, nhịp điệu thi ca và những rung cảm tinh khôi sâu thẳm trong trái tim.',
    theme: 'theme-literature'
  },
  'TIỂU LUẬN': {
    icon: 'fa-solid fa-file-lines',
    desc: 'Những bài viết ngắn gọn, lập luận sắc bén và góc nhìn sâu sắc về văn hóa, triết học và đời sống.',
    theme: 'theme-literature'
  },
  'TIỂU THUYẾT': {
    icon: 'fa-solid fa-book-open-reader',
    desc: 'Thế giới nhân vật đa dạng, cốt truyện sâu sắc phản ánh chân thực muôn mặt của cuộc sống.',
    theme: 'theme-literature'
  },
  'TIỂU TUYẾT': {
    icon: 'fa-solid fa-book-open-reader',
    desc: 'Thế giới nhân vật đa dạng, cốt truyện sâu sắc phản ánh chân thực muôn mặt của cuộc sống.',
    theme: 'theme-literature'
  },
  'TÌNH CẢM': {
    icon: 'fa-solid fa-heart',
    desc: 'Những câu chuyện tình người ấm áp, rung động sâu xa và vun đắp tình yêu thương trong cuộc sống.',
    theme: 'theme-music'
  },
  'TỘI PHẠM': {
    icon: 'fa-solid fa-fingerprint',
    desc: 'Tái hiện những vụ án ly kỳ, diễn biến tâm lý phức tạp và cuộc đấu tranh bảo vệ công lý.',
    theme: 'theme-business'
  },
  'TÔN GIÁO': {
    icon: 'fa-solid fa-hands-praying',
    desc: 'Tìm hiểu nguồn gốc tín ngưỡng, giáo lý tâm linh và giá trị đạo đức hướng thiện của nhân loại.',
    theme: 'theme-literature'
  },
  'TRÍ TUỆ NHÂN TẠO': {
    icon: 'fa-solid fa-robot',
    desc: 'Kỷ nguyên AI, công nghệ máy học và sự chuyển dịch đột phá trong tương lai nhân loại.',
    theme: 'theme-science'
  },
  'TRIẾT HỌC': {
    icon: 'fa-solid fa-lightbulb',
    desc: 'Suy ngẫm về bản chất sự tồn tại, chân lý nhận thức và những câu hỏi lớn của nhân loại.',
    theme: 'theme-literature'
  },
  'TRINH THÁM': {
    icon: 'fa-solid fa-user-secret',
    desc: 'Những vụ án hóc búa, đấu trí nghẹt thở và hành trình lần theo dấu vết để tìm ra chân tướng.',
    theme: 'theme-business'
  },
  'TRUYỆN DÀI': {
    icon: 'fa-solid fa-book',
    desc: 'Hành trình dẫn lối độc giả qua những câu chuyện dài tập, sâu sắc và đầy trăn trở nhân sinh.',
    theme: 'theme-literature'
  },
  'TRUYỆN NGẮN': {
    icon: 'fa-solid fa-book-bookmark',
    desc: 'Những lát cắt cô đọng của cuộc đời, gửi gắm thông điệp sâu xa qua từng câu chữ giản dị.',
    theme: 'theme-literature'
  },
  'TRUYỆN TRANH': {
    icon: 'fa-solid fa-images',
    desc: 'Thế giới hình ảnh sinh động, phong cách tranh vẽ độc đáo và cốt truyện hấp dẫn, giàu cảm xúc.',
    theme: 'theme-kids'
  },
  'TƯ DUY': {
    icon: 'fa-solid fa-brain',
    desc: 'Rèn luyện tư duy phản biện, phương pháp giải quyết vấn đề và khai mở năng lực sáng tạo vô hạn.',
    theme: 'theme-skills'
  },
  'TỰ TRUYỆN': {
    icon: 'fa-solid fa-signature',
    desc: 'Câu chuyện người thật việc thật, hành trình vượt khó và chiêm nghiệm cuộc đời từ chính tác giả.',
    theme: 'theme-literature'
  },
  'TUỔI MỚI LỚN': {
    icon: 'fa-solid fa-graduation-cap',
    desc: 'Người bạn đồng hành tâm lý, giúp định hình ước mơ và vượt qua những bỡ ngỡ tuổi trưởng thành.',
    theme: 'theme-kids'
  },
  'TÙY BÚT': {
    icon: 'fa-solid fa-pen-fancy',
    desc: 'Dòng cảm xúc tự do, góc nhìn phóng khoáng và những rung động tinh tế trước vẻ đẹp cuộc sống.',
    theme: 'theme-literature'
  },
  'TUYỂN TẬP': {
    icon: 'fa-solid fa-box-archive',
    desc: 'Tuyển tập những áng văn, bài thơ và tác phẩm đặc sắc nhất được tinh tuyển theo chủ đề.',
    theme: 'theme-literature'
  },
  'VĂN HÓA': {
    icon: 'fa-solid fa-earth-americas',
    desc: 'Khám phá bản sắc các vùng miền, phong tục tập quán và di sản văn hóa đặc sắc của nhân loại.',
    theme: 'theme-literature'
  },
  'VIỄN TƯỞNG': {
    icon: 'fa-solid fa-shuttle-space',
    desc: 'Những chuyến du hành vượt thời gian, vũ trụ huyền bí và viễn cảnh khoa học tương lai.',
    theme: 'theme-science'
  },
  'XÃ HỘI': {
    icon: 'fa-solid fa-people-group',
    desc: 'Góc nhìn đa chiều về các hiện tượng xã hội, đời sống con người và sự vận động của cộng đồng.',
    theme: 'theme-business'
  },
  'XÃ HỘI HỌC': {
    icon: 'fa-solid fa-users-viewfinder',
    desc: 'Nghiên cứu cấu trúc xã hội, mối quan hệ con người và quy luật vận hành của các cộng đồng.',
    theme: 'theme-business'
  },
  'Y HỌC': {
    icon: 'fa-solid fa-stethoscope',
    desc: 'Kiến thức y học thực chứng, chăm sóc sức khỏe và những tiến bộ cứu giúp mạng sống con người.',
    theme: 'theme-science'
  }
};

function getCategoryMeta(name) {
  if (!name) return null;
  const upper = name.trim().toUpperCase();
  if (CATEGORY_MAP[upper]) return CATEGORY_MAP[upper];

  // Try partial matches
  for (const key in CATEGORY_MAP) {
    if (upper.includes(key) || key.includes(upper)) {
      return CATEGORY_MAP[key];
    }
  }
  return null;
}

export default {
  name: 'CategoryDetail',
  components: {
    Header,
    Footer,
    BookCard
  },
  data() {
    return {
      categoryId: '',
      category: null,
      books: [],
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,
      isLoading: true,
      errorMessage: null,
      searchQuery: '',
      sortBy: 'default',
      searchTimeout: null
    };
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        if (newId) {
          this.categoryId = newId;
          this.searchQuery = '';
          this.sortBy = 'default';
          this.fetchCategoryData(0);
        }
      },
      immediate: true
    }
  },
  computed: {
    categoryIcon() {
      const meta = getCategoryMeta(this.category?.name);
      return meta?.icon || 'fa-solid fa-book-bookmark';
    },
    categoryDescription() {
      const meta = getCategoryMeta(this.category?.name);
      if (meta?.desc) return meta.desc;
      if (!this.category || !this.category.name) {
        return 'Tuyển tập những tác phẩm được chọn lọc và đánh giá cao từ cộng đồng độc giả.';
      }
      return `Tuyển tập những cuốn sách hay nhất thuộc chủ đề ${this.category.name}, được cộng đồng độc giả Lối Đọc đón nhận nồng nhiệt.`;
    },
    categoryThemeClass() {
      const meta = getCategoryMeta(this.category?.name);
      return meta?.theme || 'theme-default';
    },
    visiblePages() {
      const current = this.currentPage;
      const total = this.totalPages;
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i);
      }

      const pages = [];
      pages.push(0);

      const start = Math.max(1, current - 1);
      const end = Math.min(total - 2, current + 1);

      if (start > 1) {
        pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < total - 2) {
        pages.push('...');
      }

      pages.push(total - 1);
      return pages;
    }
  },
  methods: {
    async fetchCategoryData(page = 0) {
      this.isLoading = true;
      this.errorMessage = null;

      // Ưu tiên đọc tên thể loại từ state nếu có
      if (history.state && history.state.categoryName && !this.category) {
        this.category = {
          id: this.categoryId,
          name: history.state.categoryName
        };
        document.title = `${this.category.name} - Thể loại sách | Lối Đọc`;
      }

      try {
        const response = await axios.get(`category/v1/get-by-id/${this.categoryId}`, {
          params: {
            key: this.searchQuery ? this.searchQuery.trim() : '',
            sortBy: this.sortBy || 'default',
            page
          },
          _skip403Redirect: true
        });
        const data = response.data;
        if (data.status === '200' && data.result) {
          const res = data.result;
          this.category = {
            id: res.id,
            name: res.name
          };
          if (res.name) {
            document.title = `${res.name} - Thể loại sách | Lối Đọc`;
          }
          if (res.books) {
            const content = res.books.content || [];
            this.books = content.map(book => ({
              ...book,
              cover: book.cover && !(book.cover.startsWith('data:') || book.cover.startsWith('http'))
                ? 'data:image/png;base64,' + book.cover
                : book.cover
            }));
            this.currentPage = page;
            this.totalPages = res.books.totalPages || 0;
            this.totalElements = res.books.totalElements || 0;
          }
        } else if (data.status === '404') {
          this.category = null;
          this.books = [];
          this.totalPages = 0;
          this.totalElements = 0;
        } else {
          this.errorMessage = data.message || 'Không thể tải thông tin thể loại.';
        }
      } catch (err) {
        console.error('Error fetching category data:', err);
        this.errorMessage = err.response?.data?.message || 'Không thể kết nối đến máy chủ. Vui lòng thử lại sau.';
      } finally {
        this.isLoading = false;
      }
    },
    onSearchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.fetchCategoryData(0);
      }, 350);
    },
    onSortChange() {
      this.fetchCategoryData(0);
    },
    goToPage(page) {
      if (page >= 0 && page < this.totalPages && page !== this.currentPage) {
        this.fetchCategoryData(page);
        window.scrollTo({ top: 250, behavior: 'smooth' });
      }
    },
    changePage(page) {
      this.goToPage(page);
    },
    clearSearch() {
      this.searchQuery = '';
      this.fetchCategoryData(0);
    },
    retry() {
      this.fetchCategoryData(0);
    }
  }
};
